import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_home_screen",
  tabindex: "-1",
  "data-bs-backdrop": "static"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_7 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_8 = { class: "row align-items-end" }
const _hoisted_9 = { class: "col-md-12 fv-row" }
const _hoisted_10 = { class: "row align-items-end" }
const _hoisted_11 = { class: "col-md-12 fv-row" }
const _hoisted_12 = { class: "row align-items-end" }
const _hoisted_13 = { class: "d-flex flex-column  fv-row mt-1" }
const _hoisted_14 = { class: "row align-items-end" }
const _hoisted_15 = { class: "col-md-12 fv-row" }
const _hoisted_16 = { class: "row align-items-end" }
const _hoisted_17 = { class: "col-md-12" }
const _hoisted_18 = { class: "row align-items-end" }
const _hoisted_19 = { class: "fv-row mb-5" }
const _hoisted_20 = { class: "d-flex flex-stack" }
const _hoisted_21 = { class: "me-5" }
const _hoisted_22 = { class: "fs-5 fw-bold" }
const _hoisted_23 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_24 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_25 = { class: "row align-items-end" }
const _hoisted_26 = {
  key: 0,
  class: "col-md-12 upload-image-col"
}
const _hoisted_27 = { class: "upload-image-box mt-2" }
const _hoisted_28 = { class: "upload-box" }
const _hoisted_29 = { class: "add-image" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-camera-retro" })
], -1)
const _hoisted_31 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_32 = { class: "hover-effect" }
const _hoisted_33 = { class: "image-heading" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_36 = { class: "modal-footer flex-center" }
const _hoisted_37 = {
  type: "reset",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_38 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Input = _resolveComponent("Input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_Image = _resolveComponent("Image")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          ref: "addHomeScreenForm",
          model: _ctx.addHomeScreenData
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("h2", null, _toDisplayString(_ctx.$t('message.ADD')) + " " + _toDisplayString(_ctx.$t('message.HOME_SCREEN')), 1),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_el_tabs, {
                    modelValue: _ctx.tabsValue,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.tabsValue = $event)),
                    type: "card",
                    onTabClick: _ctx.tabClickHandler
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.locales, (item) => {
                        return (_openBlock(), _createBlock(_component_el_tab_pane, {
                          key: item.value,
                          label: item.label,
                          name: item.value
                        }, null, 8, ["label", "name"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onTabClick"]),
                  _createVNode("div", _hoisted_9, [
                    _createVNode(_component_Input, {
                      type: "text",
                      name: "label",
                      label: `${_ctx.$t('message.LABEL')} (${_ctx.tabsValue})`,
                      placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.LABEL')}`,
                      requiredMsg: `${_ctx.$t('message.LABEL')} ${_ctx.$t('message.IS_REQUIRED')}`,
                      "onUpdate:label": _cache[2] || (_cache[2] = ($event: any) => (_ctx.addHomeScreenData.label = $event)),
                      target: "label",
                      onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateLabelValue(_ctx.addHomeScreenData.label))),
                      value: _ctx.addHomeScreenData.label
                    }, null, 8, ["label", "placeholder", "requiredMsg", "value"])
                  ])
                ]),
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode(_component_Input, {
                      type: "text",
                      name: "title",
                      label: `${_ctx.$t('message.TITLE')} (${_ctx.tabsValue})`,
                      placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.TITLE')}`,
                      requiredMsg: `${_ctx.$t('message.TITLE')} ${_ctx.$t('message.IS_REQUIRED')}`,
                      title: _ctx.addHomeScreenData.title,
                      "onUpdate:title": _cache[4] || (_cache[4] = ($event: any) => (_ctx.addHomeScreenData.title = $event)),
                      target: "title",
                      onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateTitleValue(_ctx.addHomeScreenData.title))),
                      value: _ctx.addHomeScreenData.title
                    }, null, 8, ["label", "placeholder", "requiredMsg", "title", "value"])
                  ])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _createVNode(_component_Input, {
                      type: "textarea",
                      name: "description",
                      label: `${_ctx.$t('message.DESCRIPTION')} (${_ctx.tabsValue})`,
                      placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.DESCRIPTION')}`,
                      requiredMsg: `${_ctx.$t('message.DESCRIPTION')} ${_ctx.$t('message.IS_REQUIRED')}`,
                      description: _ctx.addHomeScreenData.description,
                      "onUpdate:description": _cache[6] || (_cache[6] = ($event: any) => (_ctx.addHomeScreenData.description = $event)),
                      target: "description",
                      onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateValueDescription(_ctx.addHomeScreenData.description))),
                      value: _ctx.addHomeScreenData.description
                    }, null, 8, ["label", "placeholder", "requiredMsg", "description", "value"])
                  ])
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, [
                    _createVNode(_component_Input, {
                      type: "text",
                      name: "button_text",
                      label: `${_ctx.$t('message.BUTTON_TEXT')} (${_ctx.tabsValue})`,
                      placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.BUTTON_TEXT')}`,
                      requiredMsg: `${_ctx.$t('message.BUTTON_TEXT')} ${_ctx.$t('message.IS_REQUIRED')}`,
                      button_text: _ctx.addHomeScreenData.button_text,
                      "onUpdate:button_text": _cache[8] || (_cache[8] = ($event: any) => (_ctx.addHomeScreenData.button_text = $event)),
                      target: "button_text",
                      onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateButtonTextValue(_ctx.addHomeScreenData.button_text))),
                      value: _ctx.addHomeScreenData.button_text
                    }, null, 8, ["label", "placeholder", "requiredMsg", "button_text", "value"])
                  ])
                ]),
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode(_component_Input, {
                      type: "text",
                      name: "button_link",
                      label: `${_ctx.$t('message.BUTTON_LINK')}`,
                      placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.BUTTON_LINK')}`,
                      requiredMsg: `${_ctx.$t('message.BUTTON_LINK')} ${_ctx.$t('message.IS_REQUIRED')}`,
                      button_link: _ctx.addHomeScreenData.button_link,
                      "onUpdate:button_link": _cache[10] || (_cache[10] = ($event: any) => (_ctx.addHomeScreenData.button_link = $event)),
                      target: "button_link",
                      value: _ctx.addHomeScreenData.button_link
                    }, null, 8, ["label", "placeholder", "requiredMsg", "button_link", "value"])
                  ])
                ]),
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, [
                    _createVNode("div", _hoisted_20, [
                      _createVNode("div", _hoisted_21, [
                        _createVNode("label", _hoisted_22, _toDisplayString(`${_ctx.$t('message.HOME_SCREEN')}
                                            ${_ctx.$t('message.STATUS')}`), 1),
                        _createVNode("div", _hoisted_23, _toDisplayString(`${_ctx.$t('message.ACCOUNT')}
                                            ${_ctx.$t('message.ACTIVATE_AND_DEACTIVATE')}`), 1)
                      ]),
                      _createVNode("span", _hoisted_24, [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.addHomeScreenData.status,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.addHomeScreenData.status = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_25, [
                  (_ctx.previewImage.length == 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_26, [
                        _createVNode("div", _hoisted_27, [
                          _createVNode("div", _hoisted_28, [
                            _createVNode("div", _hoisted_29, [
                              _createVNode("input", {
                                type: "file",
                                class: "upload-btn",
                                accept: "image/png, image/jpg, image/jpeg",
                                onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args)))
                              }, null, 32),
                              _hoisted_30,
                              _createVNode("strong", null, _toDisplayString(_ctx.$t('message.UPLOAD_IMAGES')), 1),
                              _createVNode("span", null, "JPG, GIF " + _toDisplayString(_ctx.$t('message.OR')) + " PNG " + _toDisplayString(_ctx.$t('message.FORMAT')) + " (max size 2MB)", 1)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.previewImage.length != 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_31, [
                      _createVNode("div", _hoisted_32, [
                        _createVNode("img", {
                          src: _ctx.previewImage[0].src,
                          alt: `${_ctx.$t('message.UPLOADED_IMAGES')}`,
                          class: "image-thumbnail",
                          style: {}
                        }, null, 8, ["src", "alt"]),
                        _createVNode("span", _hoisted_33, [
                          _createVNode("i", {
                            class: "fas fa-search",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showMedia(0)))
                          }),
                          _hoisted_34,
                          _createVNode("i", {
                            class: "fas fa-trash-alt",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.removeMedia(0, _ctx.previewImage[0].id)))
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_35,
                _createVNode(_component_Image)
              ])
            ]),
            _createVNode("div", _hoisted_36, [
              _createVNode("button", _hoisted_37, _toDisplayString(_ctx.$t('message.CANCEL')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-custom",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.submitHomeScreenForm()))
              }, [
                _createVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('message.SUBMIT')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
}